import React from 'react';

import Box from '@amzn/meridian/box';
import { type BoxProps } from '@amzn/meridian/box/box';
import ButtonGroup, { ButtonOption } from '@amzn/meridian/button-group';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { IdentifyBodyLocationEnum } from 'src/utils/jmrUtils';

// **** Types **** //

interface IdentifyBodyLocationFieldProps extends BoxProps {
  bodyLocationValue: IdentifyBodyLocationEnum | null;
  onChangeBodyLocationValue: (newValue: IdentifyBodyLocationEnum | null) => void;
  isDisabled: boolean;
}

// **** Components **** //

/**
 * Select the human-body location for a restriction.
 */
const IdentifyBodyLocationField = ({
  bodyLocationValue,
  onChangeBodyLocationValue,
  isDisabled,
  ...boxProps
}: IdentifyBodyLocationFieldProps) => {
  // "Normal" display state
  return (
    <Box data-testid="new-jmr__identify-body-location-field" {...boxProps}>
      <Row>
        <Text>
          Identify Body Location{' '}
          <Text tag="span" color="secondary">
            (Optional)
          </Text>
        </Text>
      </Row>
      <ButtonGroup
        value={bodyLocationValue}
        onChange={(v) => {
          const newValue = v === bodyLocationValue ? null : v;
          onChangeBodyLocationValue(newValue);
        }}
      >
        <ButtonOption disabled={isDisabled} value={IdentifyBodyLocationEnum.LEFT}>
          Left
        </ButtonOption>
        <ButtonOption disabled={isDisabled} value={IdentifyBodyLocationEnum.RIGHT}>
          Right
        </ButtonOption>
        <ButtonOption disabled={isDisabled} value={IdentifyBodyLocationEnum.BOTH}>
          Both
        </ButtonOption>
      </ButtonGroup>
    </Box>
  );
};

// **** Export **** //

export default IdentifyBodyLocationField;
